<script setup>
import { computed } from 'vue'
import markdownit from 'markdown-it'

const md = markdownit()
const props = defineProps({
	content: {
		type: String,
		default: '',
	},
})
const html = computed(() => (props.content ? md.render(props.content) : ''))
</script>

<template>
	<div class="markdown" v-html="html" />
</template>
